module.exports = __webpack_public_path__ + "static/img/绑定成功.f85c039.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/绑定成功.png
// module id = 298
// module chunks = 382